import React from "react";
import { object, number, bool, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import BigNumber from "../../atoms/BigNumber";

import "./numberedHeadline.m.css";

const NumberedHeadline = ({ story, headlineNumber, iconEnd = false, className = "" }) => {
  return (
    <div styleName="wrapper" className={`numbered-headline ${className}`}>
      <BigNumber headlineNumber={headlineNumber} />
      <div>
        <NewsHeadline story={story} showSponsor={false} iconEnd={iconEnd} />
      </div>
    </div>
  );
};

NumberedHeadline.propTypes = {
  story: object,
  headlineNumber: number,
  iconEnd: bool,
  className: string,
};

export default NumberedHeadline;
